import { render, staticRenderFns } from "./DiaDs.vue?vue&type=template&id=c75bf970&"
import script from "./DiaDs.vue?vue&type=script&lang=js&"
export * from "./DiaDs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports